import { GetQueueAttachment } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetQueueAttachment extends BaseHttpService<GetQueueAttachment.Model> implements GetQueueAttachment {
  async get(): Promise<GetQueueAttachment.Model> {
    return await this.request('get', {});
  }
}
